import React from 'react';
import { accoladesData } from '../../data/mock';

// Logo URLs
const CLUB_TRAVEL_LOGO = "https://customer-assets.emergentagent.com/job_vtravelconsult/artifacts/jxyn5a7u_club%20travel%20logo.jpg";
const FLIGHT_CENTRE_LOGO = "https://customer-assets.emergentagent.com/job_vtravelconsult/artifacts/txbzv7ox_flight%20centre%20logo.png";
const ABSA_LOGO = "https://customer-assets.emergentagent.com/job_vtravelconsult/artifacts/6totty7x_absa%20logo.jpg";
const BEST_THING_EVER_LOGO = "https://customer-assets.emergentagent.com/job_vtravelconsult/artifacts/rdemhhql_best%20thing%20ever%20logo.jpeg";
const ORTJET_LOGO = "https://customer-assets.emergentagent.com/job_vtravelconsult/artifacts/jjb386r0_ortjet%20logo.jpg";

const EmblemIcon = ({ index }) => {
  const emblems = [
    // Club Travel Group - Logo
    <div key="club" className="relative">
      <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-white flex items-center justify-center">
        <img src={CLUB_TRAVEL_LOGO} alt="Club Travel Group" className="w-full h-full object-contain" />
      </div>
    </div>,
    // Flight Centre Million Dollar - Logo
    <div key="fc" className="relative">
      <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-white flex items-center justify-center">
        <img src={FLIGHT_CENTRE_LOGO} alt="Flight Centre" className="w-full h-full object-contain" />
      </div>
    </div>,
    // ABSA Global Woman in Leadership - Image
    <div key="absa1" className="relative">
      <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-white flex items-center justify-center">
        <img src={ABSA_LOGO} alt="ABSA Jewish Achievers" className="w-full h-full object-contain" />
      </div>
    </div>,
    // Best Thing Ever - Image
    <div key="bte" className="relative">
      <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-white flex items-center justify-center">
        <img src={BEST_THING_EVER_LOGO} alt="Best Thing Ever" className="w-full h-full object-contain" />
      </div>
    </div>,
    // OrtJet Shining Light - Image
    <div key="ortjet" className="relative">
      <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-white flex items-center justify-center">
        <img src={ORTJET_LOGO} alt="OrtJet Shining Light Awards" className="w-full h-full object-contain" />
      </div>
    </div>,
  ];
  return emblems[index] || emblems[0];
};

const Accolades = () => {
  return (
    <section className="bg-[#0a1628] py-14 sm:py-20 lg:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <p
            className="text-[#c9a96e] text-[10px] sm:text-[11px] tracking-[0.3em] uppercase mb-3 sm:mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {accoladesData.tagline}
          </p>
          <h2
            className="text-white text-2xl sm:text-3xl md:text-4xl font-light"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {accoladesData.title}
          </h2>
        </div>

        {/* Awards Grid - Responsive layout */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-6">
          {accoladesData.awards.map((award, index) => (
            <div
              key={award.id}
              className="text-center group p-2 sm:p-0"
            >
              {/* Emblem */}
              <div className="flex justify-center mb-3 sm:mb-5">
                <div className="w-14 h-14 sm:w-20 sm:h-20 border border-[#c9a96e]/30 flex items-center justify-center transition-all duration-300 group-hover:border-[#c9a96e]/60 group-hover:bg-[#c9a96e]/5">
                  <EmblemIcon index={index} />
                </div>
              </div>

              {/* Award Info */}
              <h3
                className="text-white text-xs sm:text-base font-light mb-0.5 sm:mb-1 leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {award.title}
              </h3>
              <p
                className="text-[#c9a96e] text-[8px] sm:text-[10px] tracking-[0.15em] uppercase mb-1 sm:mb-2 leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {award.subtitle}
              </p>
              <span
                className="text-white/40 text-[10px] sm:text-xs"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {award.year}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accolades;
